import type { ReactNode } from 'react';
import { useT } from '../i18n/index.ts';

/**
 * Recent-transaction frame for A-24. When the cold reader could not return
 * rows older than the hot line, say so. An empty hot portion must not look
 * like an account with no transactions.
 */
export function TransactionListFrame({
  incomplete,
  count,
  empty,
  children,
}: {
  readonly incomplete: boolean;
  readonly count: number;
  readonly empty: ReactNode;
  readonly children: ReactNode;
}): JSX.Element {
  const t = useT();
  return (
    <div className="flex flex-col gap-3">
      {incomplete ? (
        <p
          role="status"
          data-testid="earlier-records-unreadable"
          className="m-0 rounded-lg border border-warn-line bg-warn-dim px-4 py-3 text-dense text-warn"
        >
          {t('ledger.earlier_records_unreadable')}
        </p>
      ) : null}
      {count === 0 && !incomplete ? empty : null}
      {count > 0 ? children : null}
    </div>
  );
}
